import { useMemo } from 'react'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { DynamicEmsData } from '../../types'
import { usePortalQuery } from 'src/Libs/api'
import { getDynamicEmsData } from '../../api/dynamic-ems.api'
import { fromDateForModal, toDateForModal } from 'src/Libs/dashboard-widgets/utils/dateUtils'

/**
 * Hook to fetch the dynamic ems data
 */
export const useDynamicEmsData = (
  installationId: string | undefined,
  start?: string,
  end?: string,
  enabled = true
): { data: DynamicEmsData[]; isLoading: boolean } => {
  const startDate = start ?? fromDateForModal.format()
  const endDate = end ?? toDateForModal.format()
  const authFetch = useAuthFetchWithResponse()
  const { data, isLoading } = usePortalQuery({
    queryKey: ['dynamic-ems-data', installationId, start, end],
    staleTime: 0,
    queryFn: () => getDynamicEmsData(installationId, authFetch, startDate, endDate),
    select: data => data ?? [],
    enabled: enabled,
  })

  const emsData = useMemo(() => data ?? [], [data])

  return { data: emsData, isLoading }
}
